import { useEffect, useRef, MutableRefObject } from "react";

export const useMountedRef = (): MutableRefObject<boolean> => {
    const isMountedRef = useRef(false);
    useEffect(() => {
        isMountedRef.current = true;
        return (): void => {
            isMountedRef.current = false;
        };
    });

    return isMountedRef;
};
